import { render, staticRenderFns } from "./ValTiposDocumentosList.vue?vue&type=template&id=3b0d6d74&"
import script from "./ValTiposDocumentosList.vue?vue&type=script&lang=js&"
export * from "./ValTiposDocumentosList.vue?vue&type=script&lang=js&"
import style0 from "./ValTiposDocumentosList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports